
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hjhCz", function(module, exports) {

$parcel$export(module.exports, "LazyAddPersonalSpaceDialog", () => $4367945ac32e8223$export$b878bc0015f3472e);

var $jmjWc = parcelRequire("jmjWc");

const $4367945ac32e8223$export$b878bc0015f3472e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LVIQc",
    name: "LazyAddPersonalSpaceDialog",
    loader: async ()=>(await (parcelRequire("93So4"))).AddPersonalSpaceDialog
});

});
parcelRegister("93So4", function(module, exports) {

let $698e950fc924b1b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $698e950fc924b1b0$var$load("hDR7w"),
    $698e950fc924b1b0$var$load("ffEVr"),
    $698e950fc924b1b0$var$load("c6MKV"),
    $698e950fc924b1b0$var$load("aZinD"),
    $698e950fc924b1b0$var$load("joJy8"),
    $698e950fc924b1b0$var$load("aHE9G"),
    $698e950fc924b1b0$var$load("4AAsh")
]).then(()=>parcelRequire('YvPDh'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("hOfle", function(module, exports) {

$parcel$export(module.exports, "useWebItemMapper", () => $9abf739da8d121fb$export$fb03cba5560d3c7b);

var $2nPZH = parcelRequire("2nPZH");

var $fTDBP = parcelRequire("fTDBP");

var $dPJCf = parcelRequire("dPJCf");

var $cfdiZ = parcelRequire("cfdiZ");
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $9abf739da8d121fb$var$i18n = (0, $2nPZH.defineMessages)({
    'system.user/adg3-section': {
        id: "navigation.help.us.improve",
        defaultMessage: "Help us improve"
    },
    'system.user/user-content': {
        id: "navigation.adg3.user.profile.user-content",
        defaultMessage: "Confluence"
    },
    'system.help/pages': {
        id: "navigation.help.name",
        defaultMessage: "Help"
    },
    'system.help/pages/legal-section': {
        id: "navigation.system.help.legal",
        defaultMessage: "Legal"
    }
});
const $9abf739da8d121fb$export$fb03cba5560d3c7b = (webItems, webSections, options)=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const items = [];
    if (webItems && webItems.length) {
        const groupedSections = (0, (/*@__PURE__*/$parcel$interopDefault($fTDBP)))(webItems, 'section');
        webSections.forEach((sectionName)=>{
            if (!sectionName) return;
            const webItemRecords = groupedSections[sectionName];
            if (!webItemRecords) return;
            const tempItems = webItemRecords.map((webItemRecord)=>(0, $cfdiZ.mapWebItem)(webItemRecord, push, options?.userId, webItemRecord.moduleKey && options?.callbackActions ? options?.callbackActions[webItemRecord.moduleKey] : undefined)).filter((item)=>!!item);
            items.push({
                heading: $9abf739da8d121fb$var$i18n.hasOwnProperty(sectionName) ? {
                    ...$9abf739da8d121fb$var$i18n[sectionName]
                } : null,
                items: tempItems
            });
        });
    }
    return items;
};

});
parcelRegister("cfdiZ", function(module, exports) {

$parcel$export(module.exports, "mapWebItem", () => $ce34965c368cb83e$export$62ed5eb75de5c4d9);
/* eslint-disable no-console */ 
var $jiJCD = parcelRequire("jiJCD");

var $gwFzn = parcelRequire("gwFzn");

var $izoLT = parcelRequire("izoLT");

var $jlIaF = parcelRequire("jlIaF");
var $1NBp8 = parcelRequire("1NBp8");

var $hjhCz = parcelRequire("hjhCz");

var $cMvQV = parcelRequire("cMvQV");

var $4ABGs = parcelRequire("4ABGs");

var $iaMpJ = parcelRequire("iaMpJ");

var $9HcaK = parcelRequire("9HcaK");

var $8a0sN = parcelRequire("8a0sN");
(0, $cMvQV.setUserAgent)();
const $ce34965c368cb83e$var$addQueryParamsToUrl = function addQueryParamsToUrl(params, url) {
    const parsedUrl = {
        ...(0, $jiJCD.parse)(url, true),
        search: undefined
    };
    parsedUrl.query = Object.assign({}, parsedUrl.query, params);
    return (0, $jiJCD.format)(parsedUrl);
};
const $ce34965c368cb83e$var$cleanURL = (url, userId)=>url.replace('$generalUtil.doubleUrlEncode($helper.action.authenticatedUser.name)', userId);
/**
 * A connect add-on web-item with `ap-dialog` or `ap-inline-dialog` class name will trigger opening Connect Dialog.
 * @param styleClass
 * @returns {boolean}
 */ const $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog = (styleClass)=>styleClass.indexOf('ap-dialog') >= 0 || styleClass.indexOf('ap-inline-dialog') >= 0;
/**
 * Add `action` for a Atlaskit dropdown menu item so that when dropdown menu item is selected, `action` is called and trigger click event on anchor element automatically.
 * @param {Object} item - dropdown menu object. A new `action` attribute will be added.
 * @returns {Function} a callback function which is used to pass `ref` prop.
 */ const $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor = (item)=>{
    return (anchorEl)=>{
        item.action = ()=>anchorEl.click();
    };
};
/**
 * createFakeWebDriverTarget will add an invisible dom element in the dropdown item, which allows old pageobjects of
 * AUIDropdown to target atlaskit dropdowns. Hopefully it's temporary.
 *
 * @param id
 */ const $ce34965c368cb83e$var$createFakeWebDriverTarget = (id)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-primitives-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        id: id,
        style: {
            opacity: 0
        },
        "aria-hidden": true
    }, "-");
const $ce34965c368cb83e$var$getMobileAppAnalyticsEvent = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'navigationMenuItem',
        actionSubjectId: 'getMobileApp',
        objectType: null,
        objectId: null,
        source: 'globalNavigation',
        attributes: {
            browser: `${(0, $cMvQV.friendlyName)()}-${(0, $cMvQV.version)()}`
        }
    }
};
const $ce34965c368cb83e$var$createAboutConfluenceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4ABGs.LazyAboutConfluenceDialog), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createGetMobileAppDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iaMpJ.LazyGetMobileAppDialog), {
        onClose: onClose,
        analyticsEvent: $ce34965c368cb83e$var$getMobileAppAnalyticsEvent
    });
const $ce34965c368cb83e$var$createGiveFeedbackDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9HcaK.LazyGiveFeedbackDialog), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createAddPesonalSpaceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hjhCz.LazyAddPersonalSpaceDialog), {
        onClose: onClose
    });
const $ce34965c368cb83e$export$62ed5eb75de5c4d9 = ({ url: url, params: params, label: label, moduleKey: moduleKey, id: id = '', tooltip: tooltip = '', styleClass: styleClass = '' }, push, userId, callbackAction)=>{
    label = (0, (/*@__PURE__*/$parcel$interopDefault($izoLT)))(label);
    switch(moduleKey){
        case 'confluence-about':
            const about = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAboutConfluenceDialog,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('confluence-about-link'),
                content: label
            };
            return about;
        case 'confluence-mobile-app-help-menu':
            return {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createGetMobileAppDialog,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('confluence-get-mobile-app'),
                content: label
            };
        //we are removing gadgets
        case 'gadget-directory':
            const gadget = null;
            return gadget;
        case 'user-history':
            const userHistory = {
                key: moduleKey,
                action: ()=>console.log('open ViewRecentsModalContainer'),
                content: label
            };
            return userHistory;
        case 'user-profile':
            const additionalQueryParamsForAnalytics = 'src=usermenu';
            const userProfileUrl = `${(0, $jlIaF.CONTEXT_PATH)}/people/${userId}?${additionalQueryParamsForAnalytics}`;
            return {
                key: moduleKey,
                href: userProfileUrl,
                content: label,
                title: tooltip
            };
        case 'keyboard-shortcuts-dialog-help-menu':
            const keyboardShortcuts = {
                key: moduleKey,
                action: callbackAction,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('keyboard-shortcuts-link'),
                content: label
            };
            return keyboardShortcuts;
        case 'create-personal-space':
            const createPersonalSpace = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAddPesonalSpaceDialog,
                content: label
            };
            return createPersonalSpace;
        case 'personal-space':
            const personalSpace = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: url,
                title: tooltip
            };
            return personalSpace;
        case 'admin-restore-personal-space':
            const adminRestorePersonalSpace = {
                key: moduleKey,
                action: callbackAction,
                content: label,
                title: tooltip
            };
            return adminRestorePersonalSpace;
        case 'my-tasks-menu-item':
            const task = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: `${(0, $jlIaF.CONTEXT_PATH)}/home/tasks`,
                title: tooltip
            };
            return task;
        case 'adg3-give-feedback':
            const giveFeedback = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createGiveFeedbackDialog,
                content: label
            };
            return giveFeedback;
        case 'user-favourites':
            const userFavourites = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: (0, $1NBp8.MY_SAVED_FOR_LATER).toUrl(),
                title: tooltip
            };
            return userFavourites;
        case 'user-theme':
            const userThemePreference = {
                key: moduleKey,
                component: (0, $8a0sN.ThemeMenuItem),
                content: label,
                title: tooltip,
                action: callbackAction,
                closeAction: ()=>{} // No-op, don't close
            };
            return userThemePreference;
        case 'login':
            const { pathname: pathname, search: search, hash: hash } = window.location;
            let currentLocation = pathname + search + hash;
            if (currentLocation.startsWith((0, $jlIaF.CONTEXT_PATH))) currentLocation = currentLocation.slice((0, $jlIaF.CONTEXT_PATH).length);
            const login = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$addQueryParamsToUrl({
                    os_destination: currentLocation
                }, url),
                content: label
            };
            return login;
        case 'logout':
            const logout = {
                key: moduleKey,
                action: ()=>{
                    push(url);
                },
                content: label
            };
            return logout;
        default:
            const item = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$cleanURL(url, userId),
                target: params && params.target || '_self',
                content: label,
                title: tooltip
            };
            const shouldRenderProxyAnchor = $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog(styleClass);
            item.iconAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, id ? $ce34965c368cb83e$var$createFakeWebDriverTarget(id) : null, shouldRenderProxyAnchor ? // eslint-disable-next-line jsx-a11y/anchor-has-content, @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                href: item.href,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: styleClass,
                ref: $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor(item)
            }) : null);
            if (shouldRenderProxyAnchor) {
                // `item.action` value will be overridden by `ref` callback.
                // prevent rendering anchor element for dropdown menu item because there is a above proxy anchor
                // which helps to trigger a click event when dropdown menu item is selected.
                item.href = '';
                item.target = '';
            }
            return item;
    }
};

});
parcelRegister("4ABGs", function(module, exports) {

$parcel$export(module.exports, "LazyAboutConfluenceDialog", () => $3577c171740792d7$export$66c678344942e78);

var $jmjWc = parcelRequire("jmjWc");

const $3577c171740792d7$export$66c678344942e78 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "l42Eo",
    name: "LazyAboutConfluenceDialog",
    loader: async ()=>(await (parcelRequire("eH8MV"))).AboutConfluenceDialog
});

});
parcelRegister("eH8MV", function(module, exports) {

let $ab2be5f55ba40dfe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ab2be5f55ba40dfe$var$load("joJy8"),
    $ab2be5f55ba40dfe$var$load("aHE9G"),
    $ab2be5f55ba40dfe$var$load("4ukY5")
]).then(()=>parcelRequire('ea6sq'));

});


parcelRegister("iaMpJ", function(module, exports) {

$parcel$export(module.exports, "LazyGetMobileAppDialog", () => $feef60c6aacc0d69$export$85b485fc81d2fc96);

var $jmjWc = parcelRequire("jmjWc");

const $feef60c6aacc0d69$export$85b485fc81d2fc96 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZ0ta",
    name: "LazyGetMobileAppDialog",
    loader: async ()=>(await (parcelRequire("5YCqr"))).GetMobileAppDialog
});

});
parcelRegister("5YCqr", function(module, exports) {

let $45a05cd59e6b53b2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $45a05cd59e6b53b2$var$load("joJy8"),
    $45a05cd59e6b53b2$var$load("aHE9G"),
    $45a05cd59e6b53b2$var$load("8AM1y")
]).then(()=>parcelRequire('hgh2B'));

});


parcelRegister("9HcaK", function(module, exports) {

$parcel$export(module.exports, "LazyGiveFeedbackDialog", () => $70f1925d36f87de3$export$833e3c61be5fbc6f);

var $jmjWc = parcelRequire("jmjWc");

const $70f1925d36f87de3$export$833e3c61be5fbc6f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pg4P3",
    name: "LazyGiveFeedbackDialog",
    loader: async ()=>(await (parcelRequire("jdYDQ"))).GiveFeedbackDialog
});

});
parcelRegister("jdYDQ", function(module, exports) {

let $dfee456045ec82a3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $dfee456045ec82a3$var$load("hDR7w"),
    $dfee456045ec82a3$var$load("ffEVr"),
    $dfee456045ec82a3$var$load("joJy8"),
    $dfee456045ec82a3$var$load("aHE9G"),
    $dfee456045ec82a3$var$load("6wPv6")
]).then(()=>parcelRequire('hEuLk'));

});


parcelRegister("8a0sN", function(module, exports) {

$parcel$export(module.exports, "ThemeMenuItem", () => $86397fec8483a8db$export$d11c29d48d32448a);

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $6R5uz = parcelRequire("6R5uz");

var $cGtPE = parcelRequire("cGtPE");

var $lAsMm = parcelRequire("lAsMm");
const $86397fec8483a8db$var$ThemeMenuItemComponent = ({ item: item, isSelected: isSelected, closeMenu: closeMenu, ...linkItemProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lAsMm.ThemePopupMenu), {
        isOpen: isSelected,
        onSelected: closeMenu,
        closeMenu: linkItemProps.onClick,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cGtPE.default), {
                ...triggerProps,
                ...linkItemProps,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    spacing: "spacious",
                    label: "",
                    size: "small"
                }),
                ref: triggerRef
            }, item.content)
    });
};
const $86397fec8483a8db$export$d11c29d48d32448a = (0, $js7oX.default)($86397fec8483a8db$var$ThemeMenuItemComponent);

});
parcelRegister("lAsMm", function(module, exports) {

$parcel$export(module.exports, "ThemePopupMenu", () => $900853aff92d6b38$export$687b3538513cb3cc);

var $jmjWc = parcelRequire("jmjWc");

const $900853aff92d6b38$export$687b3538513cb3cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "sW558",
    name: "ThemePopupMenu",
    loader: async ()=>(await (parcelRequire("VKl9c"))).ThemePopupMenu
});

});
parcelRegister("VKl9c", function(module, exports) {

let $0ad9452964b3ebf2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0ad9452964b3ebf2$var$load("hDR7w"),
    $0ad9452964b3ebf2$var$load("8miHS"),
    $0ad9452964b3ebf2$var$load("8DoxJ"),
    $0ad9452964b3ebf2$var$load("ffEVr"),
    $0ad9452964b3ebf2$var$load("joJy8"),
    $0ad9452964b3ebf2$var$load("aHE9G"),
    $0ad9452964b3ebf2$var$load("943D1")
]).then(()=>parcelRequire('ddp7n'));

});





parcelRegister("kniSK", function(module, exports) {

$parcel$export(module.exports, "PopupMenuItemComponent", () => $76b9de0c86704e7a$export$d84e735b83737942);
/* PopupMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $cGtPE = parcelRequire("cGtPE");
const $76b9de0c86704e7a$var$styles = null;
const $76b9de0c86704e7a$export$d84e735b83737942 = ({ item: item, onClickHandler: onClickHandler, closeMenu: closeMenu, isSelected: isSelected })=>{
    const ItemComponent = item.component;
    const onKeyPress = (0, $gwFzn.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === 'Space') onClickHandler();
    }, [
        onClickHandler
    ]);
    const commonProps = (0, $gwFzn.useMemo)(()=>{
        const tabIndex = item.href ? undefined : 0;
        const role = item.href ? undefined : 'link';
        return {
            onClick: onClickHandler,
            closeMenu: closeMenu,
            isSelected: isSelected,
            onKeyPress: // The following 3 attributes are needed for accessibility
            // Otherwise, a link item's onClick is not usable by keyboard
            onKeyPress,
            tabIndex: // Only needed if the href attribute is missing, for accessibility
            tabIndex,
            role: role
        };
    }, [
        onClickHandler,
        isSelected,
        onKeyPress,
        item,
        closeMenu
    ]);
    return ItemComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ItemComponent, {
        item: item,
        ...commonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cGtPE.default), {
        testId: "default-popup-menu-item",
        ...item.href && {
            href: item.href
        },
        target: item.target || undefined,
        iconAfter: item.iconAfter || null,
        ...commonProps,
        className: (0, $35pXk.default)([
            "_1nrm18uv _1ydc18uv _c2waglyw _1x28glyw _1iohnqa1 _1726nqa1 _9h8h1fxt _10531fxt"
        ])
    }, item.content);
};

});


//# sourceMappingURL=HelpPanel.8ee3594b.js.map
